import { render, staticRenderFns } from "./NewsletterClientStatsExportButton.vue?vue&type=template&id=ddfe8120&scoped=true"
import script from "./NewsletterClientStatsExportButton.vue?vue&type=script&lang=js"
export * from "./NewsletterClientStatsExportButton.vue?vue&type=script&lang=js"
import style0 from "./NewsletterClientStatsExportButton.vue?vue&type=style&index=0&id=ddfe8120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe8120",
  null
  
)

export default component.exports